import { cn } from '@/lib/utils';
import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from './primitives';

export function PublicHeader({
  children,
  homeHref = '/',
}: {
  children?: ReactNode;
  homeHref?: string;
}) {
  return (
    <header className="sticky top-0 z-20 border-b border-[rgba(11,11,12,.08)] bg-white/86 backdrop-blur-[20px]">
      <nav className="mx-auto flex max-w-[1200px] items-center justify-between gap-6 px-6 py-3.5">
        <Link to={homeHref} className="flex items-center">
          <BrandMark subtitle="RETIRO DE CASAIS" />
        </Link>
        {children}
      </nav>
    </header>
  );
}

export function BackToSite() {
  return (
    <Link
      to="/"
      className="flex items-center gap-1.5 text-sm font-medium text-body transition-colors hover:text-brand"
    >
      <ChevronLeft className="size-[18px]" />
      Voltar ao site
    </Link>
  );
}

export function PublicFooterBar({ className }: { className?: string }) {
  return (
    <div
      className={cn('flex flex-wrap justify-between gap-3 text-xs text-muted', className)}
    >
      <span>
        © {new Date().getFullYear()} Comunidade Católica Apóstolos. Todos os direitos
        reservados.
      </span>
      <span>casaisencheivos.com.br</span>
    </div>
  );
}
